export default __webpack_public_path__ + "static/actions-nl-76e23a6ff7659751bd7b0a93fef6d2e0.png";